import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../app/hooks';
import { useAppDispatch } from '../app/store';
import { setCurrentDate } from '../features/calendar/calendar-slice';
import { throttle, debounce } from 'lodash';
import { DATE_FORMAT, isInView } from '../helpers/date-helpers';

export const ScrollToTop = () => {
    const dispatch = useAppDispatch();
    const currentRange = useAppSelector(state => state.calendar.currentRange);
    const currentDate = useAppSelector(state => state.calendar.currentDate);
    const [showButton, setShowButton] = useState(false);
    const [pageHeight, setPageHeight] = useState(window.innerHeight);
    const scrollToTopButtonText = useAppSelector(state => state.settings.scrollToTopButtonText);

    useEffect(() => {
        document.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    const handleScroll = throttle(() => setShowButton(window.pageYOffset > pageHeight), 250);
    const handleResize = debounce(() => setPageHeight(window.innerHeight), 250);

    const buttonClicked = () => {
        if (currentRange.startDate == currentDate) {
            // Force scroll if the current date is already at the top, but the user has scrolled away
            const currentDateKey = document.querySelector(`[data-date="${dayjs(currentDate).startOf('month').format(DATE_FORMAT)}"], [data-date-key="${dayjs(currentDate).startOf('month').format(DATE_FORMAT)}`);
            if (currentDateKey) {
                if (!isInView(currentDateKey)) {
                    currentDateKey.scrollIntoView({ block: "start" });
                    (currentDateKey as HTMLElement).focus({ preventScroll: true });
                }
            }
        }

        dispatch(setCurrentDate({
            newDate: currentRange.startDate,
            shouldChangeRange: false
        }));
    }

    return (
        <div className="ace-cal-back-to-top" data-show-button={showButton}>
            <button type="button" onClick={buttonClicked} className="btn" data-testid="navigation scrollToTop">
                {scrollToTopButtonText}
            </button>
        </div>
    )
}